import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { ONBOARDING_API } from "./apiRoutes";
import axiosAuth from "@/services/axiosAuth";

interface UseBulkDownloadUserProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">
}

const bulkDownloadUser = async (communityId: string) =>
  await axiosAuth.get(`${ONBOARDING_API(communityId)}/occupancy/template/with-data`, {
    responseType: "blob",
  });

const useBulkDownloadUser = ({
  communityId,
  queryParams
}: UseBulkDownloadUserProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["bulk-download-user", communityId],
    queryFn: () => bulkDownloadUser(communityId),
    select: (data: any) => data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useBulkDownloadUser;
